<template>
  <div>
    <h2 class="label mb10">{{locale.admin_submitcategory}}</h2>
    <div class="add">
      <input type="text" class="input"
        v-model="newSubmitCategory"
        @keyup.enter="add" />
      <button type="submit" class="btn"
        @click="add">
        {{locale.add}}
      </button>
    </div>
    <p v-if="isExist" class="colorRed mt5">{{locale.admin_code_exist}}</p>
    <p v-if="submitCategory.list.length === 0" class="noData">{{locale.submitcategory_nodata}}</p>
    <div v-else>
      <div class="mt30">
        <span class="checkbox">
          <input type="checkbox" id="required_edit_submitcategory" v-model="submitCategory.requiredEdit">
          <label for="required_edit_submitcategory">{{locale.required_check_edit}}</label>
        </span>
      </div>
      <table class="table mt15">
        <tbody>
          <tr v-for="cate in submitCategory.list" :key="cate.id">
            <Item
              :locale="locale"
              :cate="cate"
              :existCate="existCate"
              @delItem="deleteItem" />
          </tr>
        </tbody>
      </table>
    </div>
    <button type="button" class="btn btnFull btnPrimary mt15"
      @click="setCategory">
      {{locale.save}}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import Item from '@/components/Admin/SubmitCategoryItem.vue'

export default {
  name: 'SubmitCategory',
  props: [
    'locale'
  ],
  components: {
    Item
  },
  computed: {
    labelList () {
      return this.submitCategory.list ? this.submitCategory.list.map(x => x.label) : []
    },
    existCate () {
      const submitCategory = this.submitCategory.list
      const existFilter = submitCategory.filter((x, index) => submitCategory.findIndex(c => x.label === c.label) !== index).map(x => x.label)
      return existFilter
    },
    isExist () {
      const list = this.labelList
      return list.includes(this.newSubmitCategory)
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      newSubmitCategory: '',
      submitCategory: {
        list: [],
        requiredEdit: false
      }
    }
  },
  methods: {
    init () {
      this.newSubmitCategory = ''
      this.$store.dispatch('admin/getSubmitCategory').then((res) => {
        if (res) {
          if (Array.isArray(res)) {
            res = {
              list: res,
              requiredEdit: false
            }
          }
          this.submitCategory = res
        }
      })
    },
    add () {
      if (regExp.replaceAllEmpty(this.newSubmitCategory).length > 0) {
        const item = {
          id: UNIQUE.mid(),
          label: this.newSubmitCategory
        }
        this.submitCategory.list.push(item)
        this.newSubmitCategory = ''
      }
    },
    deleteItem (id) {
      this.submitCategory.list = this.submitCategory.list.filter(x => x.id !== id)
      this.setCategory()
    },
    setCategory () {
      const submitCategory = this.submitCategory
      this.$store.dispatch('admin/setSubmitCategory', submitCategory).then((res) => {
        if (res) {
          alert(this.locale.complete_save)
          this.init()
        } else {
          alert(this.locale.unknown_error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  position: relative;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
  .input {
    padding-right: 130px;
  }
}
.btn.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.noData {
  padding: 80px 0;
  text-align: center;
  font-size: 1.4em;
}
</style>
